'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = composeReducers;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composeReducers(ns) {
  for (var _len = arguments.length, reducers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    reducers[_key - 1] = arguments[_key];
  }

  !(typeof ns === 'string') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'ns should be a string but was given ' + ns + ' instead') : (0, _invariant2.default)(false) : void 0;
  reducers.forEach(function (reducer) {
    return !(typeof reducer === 'function') ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'reducer should be functions but found ' + reducer) : (0, _invariant2.default)(false) : void 0;
  });

  function composedReducer(state, action) {
    var hasChanged = false;
    return reducers.reduce(function (iteratedState, reducer) {
      var nextState = reducer(iteratedState, action);

      hasChanged = hasChanged || iteratedState !== nextState;

      return hasChanged ? nextState : iteratedState;
    }, state);
  }

  composedReducer.toString = function () {
    return ns;
  };
  return composedReducer;
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/compose-reducers.js
// module id = 568
// module chunks = 168707334958949